import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { AssessmentConstants } from '../store/assessment.constant'
import { getAssessmentSelector } from '../selectors'
import { IAssessmentState } from '../store/assessment.types'
import { saveAssessment } from '../store/assessment.actions'

export function* setComments() {
  const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
  const { comments } = assessmentState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.assessmentsStateList && pcrDoc.patient?.assessmentsStateList.length) {
        const index = pcrDoc.patient?.assessmentsStateList?.findIndex((data) => data.key === assessmentState.key)
        if (index !== -1) {
          if (pcrDoc.patient.assessmentsStateList[index].comments !== comments) {
            yield put(saveAssessment())
          }
        }
      } else {
        yield put(saveAssessment())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* setCommentsSaga() {
  yield takeLatest([AssessmentConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
